"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { GroupCardState } from "./GroupCard";
import GroupCardConfigs from "./GroupCardConfigs";
export default function GroupCardContent(t0) {
  const $ = _c(15);
  const {
    group,
    haveActiveGroupVoteAll,
    setState,
    titlePlaceholder
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const t1 = group?.name ?? "";
  const t2 = group?.name ?? titlePlaceholder ?? "";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <p title={t1} className="tw-mb-0 tw-text-xl tw-text-iron-50 tw-font-semibold tw-whitespace-nowrap tw-overflow-hidden tw-text-overflow-ellipsis tw-truncate">{t2}</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== connectedProfile?.handle || $[4] !== haveActiveGroupVoteAll || $[5] !== setState) {
    t4 = !!connectedProfile?.handle && setState && <div className="tw-flex tw-items-center tw-gap-x-3"><button onClick={e => {
        e.stopPropagation();
        setState(GroupCardState.REP);
      }} type="button" disabled={haveActiveGroupVoteAll} className={`${haveActiveGroupVoteAll ? "tw-opacity-50 tw-text-iron-600 tw-border-iron-800 tw-cursor-default" : "hover:tw-bg-iron-700 tw-border-iron-700 tw-text-iron-300 hover:tw-text-iron-50"} tw-relative tw-z-20 tw-whitespace-nowrap tw-inline-flex tw-items-center tw-bg-iron-800 tw-border tw-border-solid tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-shadow-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-transition tw-duration-300 tw-ease-out`}>Rep all</button><button onClick={e_0 => {
        e_0.stopPropagation();
        setState(GroupCardState.NIC);
      }} type="button" disabled={haveActiveGroupVoteAll} className={`${haveActiveGroupVoteAll ? "tw-opacity-50 tw-text-iron-600 tw-border-iron-800 tw-cursor-default" : "hover:tw-bg-iron-700 tw-border-iron-700 tw-text-iron-300 hover:tw-text-iron-50"} tw-relative tw-z-20 tw-whitespace-nowrap tw-inline-flex tw-items-center tw-bg-iron-800 tw-border tw-border-solid tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-shadow-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-transition tw-duration-300 tw-ease-out`}>NIC all</button></div>;
    $[3] = connectedProfile?.handle;
    $[4] = haveActiveGroupVoteAll;
    $[5] = setState;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-3 tw-justify-between">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== group) {
    t6 = <GroupCardConfigs group={group} />;
    $[10] = group;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="tw-flex-1 tw-px-4 sm:tw-px-5">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}